import { render, staticRenderFns } from "./AddNotesForArticle.vue?vue&type=template&id=29df3026"
import script from "./AddNotesForArticle.vue?vue&type=script&lang=js"
export * from "./AddNotesForArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports